import React from 'react';
import ControlDialog from '../info/control-dialog';
import { VideoPopupContent } from './video-popup-content';
import css from './video-popup.scss';
export const VideoPopup = ({
  isOpen,
  onCloseVideoPopup,
  playedFromUrl,
  closeCallback
}) => {
  const handleClosePopup = () => {
    onCloseVideoPopup();
    closeCallback();
  };
  return /*#__PURE__*/React.createElement(ControlDialog, {
    onRequestClose: handleClosePopup,
    content: /*#__PURE__*/React.createElement(VideoPopupContent, {
      onCloseVideoPopup: handleClosePopup,
      playedFromUrl: playedFromUrl
    }),
    bodyClassName: css.bodyClassName,
    contentClassName: css.contentClassName,
    dialogClass: css.dialogClass,
    overlayClassName: css.overlayClassName,
    open: isOpen,
    showCloseButton: false,
    dataPopup: "VideoPopupContent"
  });
};